const fromHeaders = [
  'token',
  'correlationId',
  'basketId',
  'authorization',
  'x-forwarded-for',
  'user-agent',
];
const fromCookies = ['sessionId', 'userId'];

const reorderIps = (ips = '') =>
  ips
    .split(',')
    .reverse()
    .map((ip) => ip?.trim())
    .filter((ip) => ip)
    .join(',');

export const getRequestOptions = (
  headers: Record<string, string>,
  source: 'cookies' | 'headers'
) => {
  const keys = source === 'cookies' ? fromCookies : fromHeaders;
  return keys.reduce((acc: Record<string, string>, header) => {
    const key = header.toLowerCase();
    let value = (headers?.[key] || headers?.[header]) ?? '';
    if (value) {
      if (key === 'x-forwarded-for') {
        value = reorderIps(value);
      }

      acc[header] = value;
    }
    return acc;
  }, {});
};
